<template>
  <div class="ml-220 mt-80">
    <form @submit.prevent="addNewComment">
      <div class="form-elems">
        <input
          name="comment_name"
          :state="validateState('comment_name')"
          v-validate="'required'"
          type="text"
          class="title-input"
          placeholder="Имя"
          v-model="name">
        <div class="w-50">
          <b-form-select
            name="comment_select"
            :state="validateState('comment_select')"
            v-validate="'required'"
            class="mt-2 w-25"
            v-model="gender"
            size="sm"
            :options="options">
            <template>
              <b-form-select-option :value="null">Выберите пол</b-form-select-option>
            </template>
          </b-form-select>
        </div>
        <textarea
          name="comment_text"
          :state="validateState('comment_text')"
          v-validate="'required'"
          type="text"
          class="text-input"
          placeholder="Комментарий"
          v-model="text"></textarea>
        <button type="submit" class="type-submit">Добавить комментарий</button>
      </div>
    </form>
    <div class="loader pt-100" v-if="loading">
      <b-spinner label="Spinning" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <div class="d-flex flex-wrap pt-4"  :class="[getComments.length%2 === 0 ? 'justify-content-between' : 'justify-content-around']" >
        <div
          class="admin-comment w-33 comms"
          v-for="(item, id) in getComments"
          :key="id">
          <img :src="[item.gender === 'male' ? require('@/assets/male.png') : require('@/assets/female.png')]" alt="">
          <p class="admin-name" v-if="editId != item.id">{{item.name}}</p>
          <b-form-input type="text" id="name" v-else :value="item.name"></b-form-input>
          <p class="admin-text" v-if="editId != item.id">{{item.text}}</p>
          <b-form-textarea type="text" id="text" v-else :value="item.text" class="text-area-min-height mt-2"></b-form-textarea>
         <div class="d-flex mt-2 justify-content-center">
           <b-button @click="delComment(item.id)" variant="danger" class="mr-2 btn-width" size="sm">Удалить</b-button>
           <b-button size="sm" variant="primary" v-if="editId === item.id" @click="saveComment(item)" class="btn-width">Сохранить</b-button>
           <b-button size="sm" variant="primary" v-else @click="changeComment(item.id)" class="btn-width">Редактировать</b-button>
         </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapMutations, mapGetters, mapActions, mapState} from 'vuex'
  import validate from '@/mixins/validate';
  export default {
    name: "AdminCommentsPage",
    mixins: [validate],
    data() {
      return {
        loading: true,
        options: [
          {value: 'male', text: 'Мужской'},
          {value: 'female', text: 'Женский'}
        ],
        editId: null,
        gender: null,
        name: '',
        text: ''
      }
    },
    async mounted() {
      this.loading = true
      const response = await this.fetchComments()
      this.setComments(response)
      this.loading = false
    },
    computed: {
      ...mapGetters('comments', ['getComments']),
      ...mapState('comments', ['comments'])
    },
    methods: {
      ...mapMutations('comments', ['setComments', 'delComment', 'setComments']),
      ...mapActions('comments',['fetchComments', 'updateComments', 'deleteComments', 'addComment']),
      async addNewComment() {
        this.$validator.validate().then( async valid => {
          if (!valid) return
          try {
            await this.addComment({name: this.name, text: this.text, gender: this.gender})
            this.resetData()
          } catch (e) {
            throw e
          }
        })
      },
      async delComment(id) {
        await this.deleteComments(id)
      },
      async changeComment(id) {
        this.editId = id
      },
      async saveComment(item) {
        this.editId = null
        let name = document.getElementById('name').value
        let text =  document.getElementById('text').value
        this.updateComments({id: item.id, name, text, gender: item.gender})
      },
      resetData() {
        this.name = ''
        this.text = ''
        this.gender = null
        this.$validator.reset()
      },
    }
  }
</script>

<style lang="scss">

  .text-area-min-height {
    min-height: 300px;
  }
  .btn-width {
    width: 120px !important;
  }
  .admin-comment {
    border-radius: 9px;
    background-color: rgba(232, 244, 255, 0.7);
    padding: 56px 32px 32px;
    position: relative;
    margin-top: 50px;
    font-family: 'Raleway', sans-serif;
    .cross {
      position: absolute;
      right: 15px;
      top: 15px;
      z-index: 111;
    }
    img {
      position: absolute;
      left: 50%;
      margin-left: -40px;
      top: -40px;
      max-width: 80px;
      width: 100%;
      display: block;
    }
    .admin-name {
      font-size: 17px;
      font-weight: 600;
      color: #19223d;
      margin-bottom: 16px;
      margin-top: 0;
      text-align: center;
    }
    .admin-text {
      font-size: 14px;
      line-height: 1.56;
      color: #19223d;
      margin: 0;
      text-align: left;
    }
  }
  @media screen and (max-width: 1100px){
    .admin-comment.w-33.comms {
      width: 100%;
    }
  }
</style>